import { Handle, Position } from "@xyflow/react";
import ChatInterface from "./ChatInterface";
import { useEffect, useRef, useState } from "react";

const AIChatNode = ({ data, isConnectable }) => {
  const chatNodeRef = useRef(null);
  const [noWheelClassName, setNoWheelClassName] = useState("nowheel");
  useEffect(() => {
    const chatNodeElement = chatNodeRef.current;

    // Ensure chatNodeElement is not null before adding the event listener
    if (chatNodeElement) {
      const handleWheel = (event) => {
        if (event.ctrlKey) {
          if (noWheelClassName === "nowheel") event.preventDefault();
          chatNodeElement.className = "diswheel";
          setNoWheelClassName("disnowheel");
        } else {
          if (noWheelClassName === "disnowheel") event.preventDefault();
          chatNodeElement.className = "nowheel";
          setNoWheelClassName("nowheel");
        }
      };

      // Add the wheel event listener without the passive option
      chatNodeElement.addEventListener("wheel", handleWheel, {
        passive: false,
      });

      // Clean up the event listener when the component unmounts
      return () => {
        chatNodeElement.removeEventListener("wheel", handleWheel);
      };
    }
  }, []);

  return (
    <div
      ref={chatNodeRef}
      className={noWheelClassName}
      style={{ overflow: "auto" }}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        style={{
          width: "20px", // Default width
          height: "20px", // Default height
          background: "white", // Default background color
          border: "2px solid #32b5e5", // Default border color
          borderRadius: "50%", // Circular shape
          position: "absolute",
          left: "-20px", // Ensure proper alignment
          top: "50%", // Align vertically
          transform: "translateY(50%)", // Center the handle
          display: "flex",
          alignItems: "center",
          lineHeight: "20px", // Match the handle's height for vertical centering
          fontSize: "12px", // Ensure text size fits
          justifyContent: "center",
          transition: "transform 0.2s, background-color 0.2s, right 0.2s", // Smooth hover transition
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(50%) scale(1.5)"; // Keep alignment and scale
          e.target.style.background = "#32b5e5"; // Change background to blue
          e.target.style.color = "white"; // Set text color to white
          e.target.innerHTML = "+"; // Add "+" symbol inside
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(50%) scale(1)"; // Reset scale while maintaining alignment
          e.target.style.background = "white"; // Reset background to white
          e.target.style.color = ""; // Clear the text color
          e.target.innerHTML = ""; // Remove "+" symbol
        }}
      />
      <ChatInterface
        data={data}
        chatNodeId={data.id}
        data_messages={data.messages}
        data_chatHistory={data.chatHistory} />
    </div>
  );
};

export default AIChatNode;
